import React from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import { IconArrowLeft } from "@velaro/velaro-component-lib/";

function BigCommerceLogo() {
  return (
    <svg viewBox="0 0 100 100" className="w-10 h-10" fill="none">
      <circle cx="50" cy="50" r="50" fill="#121118" />
      <path
        d="M22 35h56l-8 30H30L22 35z"
        fill="none"
        stroke="#34BBE6"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <circle cx="38" cy="73" r="4" fill="#34BBE6" />
      <circle cx="62" cy="73" r="4" fill="#34BBE6" />
      <path d="M22 35l-4-12H12" stroke="#34BBE6" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function BigCommerceOverview() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="font-semibold group flex items-center gap-2 justify-between mb-6">
        <div className="flex items-center gap-2">
          <div className="w-14 h-14 border-slate-300 relative mr-4 rounded border p-2 content-center flex items-center justify-center">
            <BigCommerceLogo />
          </div>
          <div>
            <div className="font-semibold text-slate-gray-800 text-lg">BigCommerce</div>
            <div className="font-normal text-slate-gray-400 text-sm">
              Connect BigCommerce to look up customers, orders, and products from your store during live chats.
            </div>
          </div>
        </div>
        <PrimaryBlueButton
          label="Connect BigCommerce"
          onClick={() => navigate("/integrations/bigcommerce/create")}
          prefixIcon={null}
          className="font-medium"
        />
      </div>

      <div className="flex border-b mb-4">
        <div className="py-2 mr-4 cursor-pointer text-slate-800 text-sm border-b-2 border-b-slate-600 px-3">
          Overview
        </div>
      </div>

      <div className="text-sm text-slate-800 space-y-3">
        <p>
          Connect BigCommerce so your support agents can instantly pull up customer accounts, order history, and product details during live conversations — without leaving Velaro.
        </p>
        <p>
          AI workflow nodes can query your BigCommerce store to look up orders by ID, search customers by email, and retrieve product information automatically during automated flows.
        </p>
        <p>
          When a visitor provides their email, Velaro can match them to their BigCommerce account and surface recent orders, lifetime value, and account status directly in the agent sidebar.
        </p>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          { title: "Customer Lookup", desc: "Search BigCommerce customers by email or name during live chats. See account details, order count, and lifetime value.", icon: "🛍️" },
          { title: "Order History", desc: "Pull up order status, tracking info, and recent purchases so agents can resolve support questions instantly.", icon: "📦" },
          { title: "AI Workflow Tools", desc: "Workflow AI nodes can query customers, orders, and products during automated flows — no agent needed.", icon: "🤖" }
        ].map((f) => (
          <div key={f.title} className="rounded-lg border border-slate-200 p-4">
            <div className="text-2xl mb-2">{f.icon}</div>
            <div className="font-medium text-slate-800 text-sm mb-1">{f.title}</div>
            <div className="text-xs text-slate-500">{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function BigCommerceBackToIntegrationLanding() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-slate-600" onClick={() => navigate("/integrations")}>
      <IconArrowLeft className="h-6 w-6" />
      Back
    </div>
  );
}

export function BigCommerceBackToOverview() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-slate-600" onClick={() => navigate("/integrations/bigcommerce/overview")}>
      <IconArrowLeft className="h-6 w-6" />
      Back to BigCommerce
    </div>
  );
}
